import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-trust',
  templateUrl: './trust.component.html',
  styleUrls: ['./trust.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TrustComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoadingResults: boolean;
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  @Input() errorWarningData: any;
  @Input() SettingForm: FormGroup;
  @Input() getDropDownValue: any;
  public isspiner: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();

  // getDropDownValue: any = [];
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    private toastr: ToastrService,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingTrustComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    // this._mainAPiServiceService.getSetData({EXCLUDESYSTEMACCOUNTS :true,EXCLUDEINVOICETEMPLATESETTINGS:true}, 'GetSystem').subscribe(response => {

    //  this.getDropDownValue = response.DATA.LISTS;
    this.behaviorService.loadingSystemSetting('templete');

    //   })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit(): void {
    this.SettingForm.controls['FIRSTTRUSTMONTH'].setValue('July');
  }

  /**
   * Save the trust settings from system settings window
   */
  saveTrust() {
    this.isspiner = true;
    let data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'Trust',
      FIRSTTRUSTMONTH: this.SettingForm.controls.FIRSTTRUSTMONTH.value,
      TRUSTSTATE: this.SettingForm.controls.TRUSTSTATE.value,
      DEFAULTTRUSTRECEIPTTYPE: this.SettingForm.controls.DEFAULTTRUSTRECEIPTTYPE.value,
      DEFAULTTRUSTWITHDRAWALTYPE: this.SettingForm.controls.DEFAULTTRUSTWITHDRAWALTYPE.value,
      TRUSTCHEQUEFORMAT: this.SettingForm.controls.TRUSTCHEQUEFORMAT.value,
      TRUSTRECEIPTCOPIES: this.SettingForm.controls.TRUSTRECEIPTCOPIES.value,
      EFTTRUSTACCOUNTNAME: this.SettingForm.controls.EFTTRUSTACCOUNTNAME.value,
      EFTTRUSTBSB: this.SettingForm.controls.EFTTRUSTBSB.value,
      EFTTRUSTACCOUNTNUMBER: this.SettingForm.controls.EFTTRUSTACCOUNTNUMBER.value,
      TRUSTACCACCOUNTNAME: this.SettingForm.controls.TRUSTACCACCOUNTNAME.value,
      TRUSTACCBSB: this.SettingForm.controls.TRUSTACCBSB.value,
      TRUSTACCACCOUNTNUMBER: this.SettingForm.controls.TRUSTACCACCOUNTNUMBER.value,
      TRUSTFIRSTWITHDRAWALCODE: this.SettingForm.controls.TRUSTFIRSTWITHDRAWALCODE.value,
      TRUSTFIRSTWITHDRAWALEFTID: this.SettingForm.controls.TRUSTFIRSTWITHDRAWALEFTID.value,
      TRUSTFIRSTTRANSFERCODE: this.SettingForm.controls.TRUSTFIRSTTRANSFERCODE.value,
      TRUSTFIRSTRECEIPTCODE: this.SettingForm.controls.TRUSTFIRSTRECEIPTCODE.value,
    };

    let data1 = { Action: 'Update', Data: data };
    (this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.isspiner = false;
          this.behaviorService.DELIVERABLES$.next(localStorage.getItem('set_active_DELIVERABLES'));
          this.toastr.success('Updated successfully');
        } else if ((response.CODE == 451 || response.CODE == 450) && response.STATUS == 'warning') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else {
          this.isspiner = false;
        }
      }),
      (error) => {
        this.isspiner = false;
        this.toastr.error(error);
      });
  }
}
